/**
 * The decimal mark the reader's language writes, read off the widget's own number
 * formatter: "," for German or French, "." otherwise.
 *
 * Exact results (fractions, significant figures, radicals) are built as strings rather
 * than formatted from floats, so they need the mark itself. Only the two common marks
 * are used — a script with its own digits keeps the period, rather than putting a
 * native separator between Latin digits.
 */
export function decimalMarkOf(format: (value: number) => string): "." | "," {
  return format(1.5).includes(",") ? "," : ".";
}
